// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"RadarPlot_graphContainer__17TsF"};